<template>
  <main ref="playground" class="playground">
    <v-stage
      ref="stage"
      :config="configStage"
      @mousedown="handleMouseDown"
      @mousemove="handleMouseMove"
      @mouseup="handleMouseUp"
    >
      <!-- Static Layer -->
      <v-layer>
        <PlaygroundTeam
          v-for="team in teams"
          :key="team.name"
          :team="team"
        />
        <v-rect
          v-if="isMouseDownAndMove"
          :config="teamToCreateConfig"
        />
        <PlaygroundGrid
          :dimensions="configStage"
        />
      </v-layer>
      <!-- Animated Layer -->
      <v-layer :config="{ listening: false }">
        <PlaygroundEmployee
          v-for="(employee) in employees"
          :key="employee.id"
          :employee="employee"
        />
        <PlaygroundPacket
          v-for="packet in packets"
          :key="packet.id"
          :packet="packet"
        />
      </v-layer>
    </v-stage>
  </main>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';

import { GRID_UNIT_PX, ROOM_CONFIG, TYPE_TEAMS } from '@/constants';
import PlaygroundEmployee from '@/components/PlaygroundEmployee.vue';
import PlaygroundGrid from '@/components/PlaygroundGrid.vue';
import PlaygroundPacket from '@/components/PlaygroundPacket.vue';
import PlaygroundTeam from '@/components/PlaygroundTeam.vue';

export default {
  name: 'Playground',
  components: {
    PlaygroundEmployee,
    PlaygroundGrid,
    PlaygroundPacket,
    PlaygroundTeam,
  },
  data() {
    return {
      canvas: undefined,
      configStage: {
        width: 300,
        height: 150,
      },
      isMouseDownAndMove: false,
      mouseDownCoord: {
        x: 0,
        y: 0,
      },
      mouseUpCoord: {
        x: 0,
        y: 0,
      },
    };
  },
  computed: {
    ...mapState(['teamTypeToCreate']),
    ...mapGetters(['employees', 'packets', 'teams']),
    teamToCreateConfig() {
      const startCoordX = Math.floor(this.mouseDownCoord.x / GRID_UNIT_PX) * GRID_UNIT_PX;
      const startCoordY = Math.floor(this.mouseDownCoord.y / GRID_UNIT_PX) * GRID_UNIT_PX;
      const width = Math.ceil(this.mouseUpCoord.x / GRID_UNIT_PX) * GRID_UNIT_PX - startCoordX;
      const height = Math.ceil(this.mouseUpCoord.y / GRID_UNIT_PX) * GRID_UNIT_PX - startCoordY;
      return ({
        x: startCoordX,
        y: startCoordY,
        width,
        height,
        fill: 'rgba(0, 88, 155, 0.2)',
      });
    },
  },
  mounted() {
    this.setCanvasWidthHeight();
  },
  methods: {
    ...mapMutations(['addRoom']),
    setCanvasWidthHeight() {
      this.configStage.width = this.$refs.playground.offsetWidth;
      this.configStage.height = this.$refs.playground.offsetHeight;
    },
    handleMouseDown(e) {
      // 只有左鍵時會觸發
      if (e.evt.which === 1) {
        const pos = this.$refs.stage.getStage().getPointerPosition();
        this.mouseDownCoord.x = pos.x;
        this.mouseDownCoord.y = pos.y;
        this.mouseUpCoord.x = pos.x;
        this.mouseUpCoord.y = pos.y;
        this.isMouseDownAndMove = true;
      }
    },
    handleMouseMove() {
      if (this.isMouseDownAndMove) {
        const pos = this.$refs.stage.getStage().getPointerPosition();
        this.mouseUpCoord.x = pos.x;
        this.mouseUpCoord.y = pos.y;
      }
    },

    handleMouseUp() {
      this.isMouseDownAndMove = false;

      // Bug: 鼠標移出 canvas 放開, 判斷重疊
      if (this.teamTypeToCreate) {
        let width = Math.abs(this.teamToCreateConfig.width);
        let height = Math.abs(this.teamToCreateConfig.height);

        if (
          this.teamTypeToCreate === TYPE_TEAMS.PANTRY
          || this.teamTypeToCreate === TYPE_TEAMS.MEETING
        ) {
          const widthFixed = ROOM_CONFIG[this.teamTypeToCreate].WIDTH;
          const heightFixed = ROOM_CONFIG[this.teamTypeToCreate].HEIGHT;
          width = Math.sign(width) * widthFixed * GRID_UNIT_PX;
          height = Math.sign(height) * heightFixed * GRID_UNIT_PX;
        }

        this.addRoom({
          x: Math.min(
            this.teamToCreateConfig.x, this.teamToCreateConfig.x + this.teamToCreateConfig.width,
          ),
          y: Math.min(
            this.teamToCreateConfig.y, this.teamToCreateConfig.y + this.teamToCreateConfig.height,
          ),
          width,
          height,
          type: this.teamTypeToCreate,
        });
      }
      this.resetPromptConfig();
    },
    resetPromptConfig() {
      this.mouseDownCoord.x = 0;
      this.mouseDownCoord.y = 0;
      this.mouseUpCoord.x = 0;
      this.mouseUpCoord.y = 0;
    },
  },
};
</script>

<style lang="less" scoped>
.playground {
  grid-area: playground;
  background-color: #fff;
}
</style>
